import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

import { Selfservice } from '../models/selfservice';

@Injectable({
  providedIn: 'root'
})
export class SelfserviceService {
  ss: Selfservice;
  code: string;

  constructor(private api: ApiService) {

  }

  init(code: string): Promise<Selfservice|null> {
    this.code = code;

    return this.reload();
  }

  reload(): Promise<Selfservice|null> {
    return new Promise((resolve, reject) => {
      this.api.show('selfservices', this.code).subscribe(
        res => {
          this.ss = res.selfservice;
          resolve(this.ss);
        },
        err => {
          reject(err);
        }
      );
    });
  }
}
